import {SharedQuestion} from './SharedQuestion';

export class LanguageSharedQuestion extends SharedQuestion {

    public question:IQuestion;

    isValid():boolean {
        super.isValid();

        return true;
    }

    validationMessage() : string {
        return null;
    }

    getValue():IValue {
        return null;
    }

    setValue(value:any) {
        
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        return true;
    }

    isAnswerEmpty(answer: IAnswer): boolean {
        return true;
    }
}